import { render, staticRenderFns } from "./DataEnrichment.vue?vue&type=template&id=59f80a80&"
import script from "./DataEnrichment.vue?vue&type=script&lang=js&"
export * from "./DataEnrichment.vue?vue&type=script&lang=js&"
import style0 from "./DataEnrichment.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports